import { useLocation, useNavigate } from "react-router-dom";
import "./TakofyBackButton.css";

const fallbackFor = (pathname) => {
  if (pathname.startsWith("/ligler/") || pathname.startsWith("/takimlar/") || pathname.startsWith("/oyuncular/")) return "/ligler";
  return "/";
};

export default function TakofyBackButton() {
  const location = useLocation();
  const navigate = useNavigate();
  const belowSiteHeader = ["/hesabim", "/privacy-policy", "/kvkk"].includes(location.pathname);
  const goBack = () => {
    if (location.key && location.key !== "default") navigate(-1);
    else navigate(fallbackFor(location.pathname), { replace: true });
  };

  return <button type="button" className={`takofy-global-back${belowSiteHeader ? " below-site-header" : ""}`} onClick={goBack} aria-label="Önceki sayfaya dön"><i aria-hidden="true">←</i><span>GERİ</span></button>;
}
